export const ChartProductUsageSkeleton = () => {
  return (
    <div className="space-y-6 py-6 px-6">
      <div className="space-y-8">
        {/* Total Value Skeleton */}
        <div className="text-center">
          <div className="h-12 w-48 bg-gray-200 rounded-lg animate-pulse mx-auto" />
        </div>

        {/* Stacked Bar Skeleton */}
        <div className="w-full">
          <div className="flex h-4 rounded-lg overflow-hidden bg-gray-200 animate-pulse">
            <div className="h-full w-1/4 bg-gray-300" />
            <div className="h-full w-1/3 bg-gray-300" />
            <div className="h-full w-1/5 bg-gray-300" />
            <div className="h-full w-1/5 bg-gray-300" />
          </div>
        </div>

        {/* Legend Skeleton */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className="space-y-1">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-gray-300 animate-pulse" />
                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
              </div>
              <div className="h-5 w-16 bg-gray-200 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
